import { render, staticRenderFns } from "./MonthlyCustomerSalesReport.vue?vue&type=template&id=ff37a29a&"
import script from "./MonthlyCustomerSalesReport.vue?vue&type=script&lang=js&"
export * from "./MonthlyCustomerSalesReport.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyCustomerSalesReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VDataTable,VFlex,VLayout,VRow,VSelect})
